import PurchaseConfirmation from './PurchaseConfirmation';
export default PurchaseConfirmation;